import CFDCompareAccountsCarousel from './cfd-compare-accounts-carousel';
import './cfd-compare-accounts-carousel.scss';

export default CFDCompareAccountsCarousel;
